<div class="modal-header">
    <h4 class="modal-title">Configuración de VoBos para: <strong>{{diagram.alias}}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography vobos-dialog-content">
    <div class="vobos-header">
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field class="sel-plant" appearance="outline">
                    <mat-label>Seleccionar plantilla</mat-label>
                    <mat-select [(ngModel)]="plantillaSeleccionada" (selectionChange)="cargaVobosPlantilla($event.value)">
                        <mat-option *ngFor="let plantilla of plantillas" [value]="plantilla.id">
                            {{plantilla.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-6 text-end">
                <button (click)="goToConfig()" mat-flat-button color="primary" class="same-height me-2"
                    style="width: 190px;">
                    <mat-icon>edit</mat-icon> Configuración VoBos
                </button>
                <button [disabled]="!selectedVobos" (click)="openModalAddPlantilla()" mat-flat-button color="primary"
                    class="same-height me-2">
                    <mat-icon>add</mat-icon> Agregar plantilla
                </button>
                <button mat-flat-button color="primary" [matMenuTriggerFor]="menuP" class="same-height"
                    [disabled]="id_plantSel == 0">
                    <mat-icon>settings</mat-icon>
                </button>
                <mat-menu #menuP="matMenu">
                    <button mat-menu-item (click)="actualizarPlantilla()">
                        <mat-icon>update</mat-icon>
                        <span>Actualizar plantilla</span>
                    </button>
                    <button mat-menu-item (click)="eliminarPlantilla()">
                        <mat-icon>delete</mat-icon>
                        <span>Eliminar plantilla</span>
                    </button>
                </mat-menu>
            </div>
        </div>
        <div *ngIf="alertEditPlantilla" class="row mt-2"
            style="background-color: #FEE9B8; border-radius: 20px 20px 20px 20px; margin-left: 0.7rem; margin-right: 2rem">
            <div class="col-sm-12 d-flex align-items-center pt-2 pb-2" style="color:#9c7b2f">
                <mat-icon class="me-3">
                    info
                </mat-icon>
                Plantilla actualizada. Puedes usar los botones de acción para guardarla como nueva o actualizarla.
            </div>
        </div>
        <div class="row mt-3 mb-1">
            <div class="col-sm-12">
                <h4>Fases Configuradas: {{totalPhasesConfiguradas}}/{{phases.length}}</h4>
            </div>
        </div>
        <mat-divider></mat-divider>
    </div>

    <div class="vobos-scroll-container" *ngIf="secondDataLoaded">
        <div class="horizontal-scroll">
            <div class="phase-card" *ngFor="let phase of phases; let phaseIndex = index">
              <mat-card class="phase-card-content">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <mat-card-title class="mb-0">{{ phase.name }}</mat-card-title>
                  <span class="badge rounded-pill text-dark fs-6" [ngClass]="{
                    'bg-custom-green': phase.totalVobosSelected === phase.vobos.length,
                    'bg-custom-yellow': phase.totalVobosSelected !== phase.vobos.length
                  }">{{phase.totalVobosSelected == undefined ? 0 : phase.totalVobosSelected}}/{{phase.vobos.length}}</span>
                </div>
      
                <div class="vobo-scroll-area">
                  <div class="vobo-list" *ngFor="let item of phase.vobos; let i = index">
                    <div class="vobo-title"><b>{{ item.area }}</b></div>
                    <div *ngIf="item.optional == 1"><b>Opcional</b></div>
                    <mat-form-field appearance="fill" class="compact-field">
                      <mat-label *ngIf="item.selectedUsers.length == 0">Sin responsables</mat-label>
                      <mat-label *ngIf="item.selectedUsers.length != 0">Responsables seleccionados</mat-label>
                      <mat-select [(ngModel)]="item.selectedUsers" (selectionChange)="onUserSelectionChange(phase.id)"
                        (closed)="clearSearch(item)" (openedChange)="onSelectOpened(phaseIndex * 100 + i)" #selectRef multiple>
                        <div class="search-option">
                          <div class="search-input-container mat-form-field-outlined">
                            <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                            <input #searchInput type="text" [(ngModel)]="item.searchTerm" (ngModelChange)="filterUsers(item)"
                              (click)="$event.stopPropagation()" matInput />
                          </div>
                          <button mat-button (click)="toggleSelectAllUsers(item, phase.id)">
                            <mat-icon>library_add</mat-icon>Seleccionar/Quitar todos
                          </button>
                        </div>
                        <mat-option *ngFor="let u of item.filteredUsers" [value]="u.id">{{ u.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>&nbsp;
    <button mat-raised-button color="primary" (click)="saveVobos()" [disabled]="!selectedVobos">
        <mat-icon>save</mat-icon> Guardar
    </button>
</mat-dialog-actions>